import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import ConversationApi from './api/ConversationApi';
import $ from 'jquery';
import type { ProfilePictureModalProps } from './types';
import './ProfilePictureModal.css';
import { buildChatWindowUrl, getAppBasePath } from '@lib/chatUrl';
import { authStorage } from '@/lib';
import { useInfoWindow } from '@/contexts/InfoWindowContext';

interface ProfilePictureModalState {
  userInfo: UserInfoItem[];
  preventOnClose: boolean;
  conversationId: number;
  isPositioned: boolean;
}

interface UserInfoItem {
  Name: string;
  Value: string;
  Priority: number;
  ConversationId?: number;
}

class ProfilePictureModal extends Component<ProfilePictureModalProps, ProfilePictureModalState>
{
  // Cache de información de usuario por personId (compartido entre instancias)
  private static userInfoCache: Map<number, UserInfoItem[]> = new Map();

  // Timer para debounce de la petición API
  private fetchDebounceTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(props: ProfilePictureModalProps)
  {
    super(props);

    this.state = {
      userInfo: [],
      preventOnClose: false,
      conversationId: 0,
      isPositioned: false,
    };

    this.closeFromOutSide = this.closeFromOutSide.bind(this);
    this.onEnterModal = this.onEnterModal.bind(this);
    this.onRemoveHoverProfilePictureModal = this.onRemoveHoverProfilePictureModal.bind(this);
    this.activaDarkMode = this.activaDarkMode.bind(this);
    this.openChatPerson = this.openChatPerson.bind(this);
    this.openInfoWindow = this.openInfoWindow.bind(this);
    this.openUserProfileView = this.openUserProfileView.bind(this);
    this.openHomeProfileView = this.openHomeProfileView.bind(this);
  }

  componentWillUnmount()
  {
    if (this.fetchDebounceTimer)
    {
      clearTimeout(this.fetchDebounceTimer);
    }
  }

  activaDarkMode(): boolean
  {
    const darkMode = localStorage.getItem('C2_enableDarkMode');
    if (darkMode === 'true' && window.location.href.indexOf('ConversationDetails') > -1)
    {
      return true;
    }
    return false;
  }

  onRemoveHoverProfilePictureModal(e: React.MouseEvent<HTMLDivElement>)
  {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const elem = document.getElementsByClassName('corgee_com_profile-picture-modal-react')[0];
    if (!elem) return;

    const box = elem.getBoundingClientRect();

    const data = {
      top: box.top + window.pageYOffset,
      right: box.right + window.pageXOffset,
      bottom: box.bottom + window.pageYOffset,
      left: box.left + window.pageXOffset,
    };

    let cont = 0;

    if (y > data.bottom) cont++;
    if (y < data.top) cont++;
    if (x < data.left) cont++;
    if (x > data.right) cont++;

    if (cont > 0)
    {
      setTimeout(() =>
      {
        this.props.closeProfilePictureModal();
      }, 250);
    }
  }

  componentDidUpdate(prevProps: ProfilePictureModalProps)
  {
    // Si el modal se cierra, cancelar cualquier petición pendiente
    if (
      prevProps.openProfilePictureDialog === true &&
      this.props.openProfilePictureDialog === false
    )
    {
      if (this.fetchDebounceTimer)
      {
        clearTimeout(this.fetchDebounceTimer);
        this.fetchDebounceTimer = null;
      }
      // Ocultar el dialog al cerrar para que no se vea en posición anterior al reabrir
      const elem = document.getElementsByClassName(
        'corgee_com_profile-picture-modal-react',
      )[0] as HTMLElement;
      if (elem)
      {
        elem.style.visibility = 'hidden';
      }
      return;
    }

    if (
      this.props.openProfilePictureDialog === true &&
      prevProps.openProfilePictureDialog !== this.props.openProfilePictureDialog &&
      ((this.props.reply && this.props.reply.CreatedById && this.props.reply.CreatedById !== 1) ||
        (!this.props.reply &&
          this.props.conversation.PersonId &&
          this.props.conversation.PersonId !== 1))
    )
    {
      const personId = this.props.reply
        ? this.props.reply.CreatedById
        : this.props.conversation.PersonId;

      // Cancelar cualquier petición pendiente (debounce)
      if (this.fetchDebounceTimer)
      {
        clearTimeout(this.fetchDebounceTimer);
      }

      // Si ya tenemos la info en cache, mostrarla inmediatamente como preview
      if (personId && ProfilePictureModal.userInfoCache.has(personId))
      {
        const cachedResult = ProfilePictureModal.userInfoCache.get(personId)!;
        this.applyUserInfo(cachedResult);
      }

      // Debounce: wait 500ms before fetching to avoid unnecessary API calls
      this.fetchDebounceTimer = setTimeout(() =>
      {
        ConversationApi.GetUserInformationByLayerInternal(this.props.api, personId!).then(
          (result: UserInfoItem[]) =>
          {
            // Guardar en cache
            if (personId)
            {
              ProfilePictureModal.userInfoCache.set(personId, result);
            }
            this.applyUserInfo(result);
          },
        );
      }, 500);
    }
  }

  /**
   * Procesa y aplica la información del usuario al estado y al DOM.
   */
  private applyUserInfo(result: UserInfoItem[])
  {
    const r = result;

    r.forEach(d =>
    {
      if (d.Name === 'Name')
      {
        d.Priority = 3;
      }
      else if (d.Name === 'ImageName')
      {
        d.Priority = 2;
      }
      else
      {
        d.Priority = d.Value !== '-' ? 1 : 0;
      }
    });

    r.sort((a, b) => b.Priority - a.Priority);

    let profilePicture_Temp = 'Images/user.png';

    if (r[1] && r[1]?.['Value'] != null && r[1]?.['Value'] !== '')
    {
      profilePicture_Temp = r[1]?.['Value'];
    }

    $('.divModalBody_react_mini .img').css(
      'background-image',
      'url(' + profilePicture_Temp + '), url(Images/user.png)',
    );

    const ConversationId = r.length > 0 && r[0]?.ConversationId ? r[0].ConversationId : 0;

    this.setState({ userInfo: r, conversationId: ConversationId }, () =>
    {
      const { positionY, positionX } = this.props;
      requestAnimationFrame(() =>
      {
        const elem = document.getElementsByClassName(
          'corgee_com_profile-picture-modal-react',
        )[0] as HTMLElement;
        if (elem)
        {
          elem.style.top = positionY + 30 + 'px';
          elem.style.left = positionX + 280 + 'px';
          elem.style.visibility = 'visible';
        }
      });
    });
  }

  closeFromOutSide()
  {
    this.setState({ preventOnClose: true }, () =>
    {
      setTimeout(() =>
      {
        if (this.state.preventOnClose)
        {
          this.props.closeProfilePictureModal();
        }
      }, 250);
    });
  }

  onEnterModal()
  {
    this.setState({ preventOnClose: false });
  }

  openChatPerson()
  {
    // Get target user person ID
    const participant2 = this.props.reply
      ? this.props.reply.CreatedById
      : this.props.conversation.PersonId;

    if (!participant2) return;

    // Get current user person ID
    const participant1 = parseInt(authStorage.getPersonId() || '0');

    if (!participant1) return;

    // Create or get private chat
    const requestParams = {
      Participant1: participant1,
      Participant2: participant2,
      ChatID: 0,
    };

    ConversationApi.createNewPrivateChat(this.props.api, requestParams)
      .then((response: any) =>
      {
        if (!response || !response.ChatID)
        {
          return;
        }

        window.open(buildChatWindowUrl(response.ChatID), '_blank');
      })
      .catch(() =>
      {
        // Silent fail
      });
  }

  openInfoWindow(_e: React.MouseEvent)
  {
    // Open user's profile card in InfoWindow
    if (this.state.conversationId && this.props.corgeeFunctions?.openInfoWindow)
    {
      this.props.corgeeFunctions.openInfoWindow(this.state.conversationId);
    }
  }

  openHomeProfileView()
  {
    const personId = this.props.reply
      ? this.props.reply.CreatedById
      : this.props.conversation.PersonId;

    // Navigate to /home with personId parameter, keeping the app base path (e.g. '/V2')
    window.location.href = `${getAppBasePath()}/home?personId=${personId}`;
  }

  openUserProfileView(e: React.MouseEvent)
  {
    this.openInfoWindow(e);
  }

  render()
  {
    const dm = this.activaDarkMode();
    const { openProfilePictureDialog, closeProfilePictureModal } = this.props;
    const { userInfo } = this.state;

    // Get target user person ID
    const targetPersonId = this.props.reply
      ? this.props.reply.CreatedById
      : this.props.conversation.PersonId;

    // Get current user person ID
    const currentPersonId = parseInt(authStorage.getPersonId() || '0');

    // Don't show chat button if it's the same user
    const canOpenChat = targetPersonId !== currentPersonId;
    const canOpenCard = true;

    // Do not show the modal if it is the 'admin' user.
    if (userInfo[0] && userInfo[0].Name === 'Name' && userInfo[0].Value === 'admin')
    {
      return <div style={{ display: 'none' }}></div>;
    }

    return (
      <div>
        <Modal
          backdrop={false}
          // Hover card: focusing the modal root scrolls the page to it, and it
          // renders unpositioned at the end of the body
          autoFocus={false}
          enforceFocus={false}
          bsClass="corgee_com_profile-picture-modal-outside"
          show={openProfilePictureDialog}
          onHide={closeProfilePictureModal}
          dialogClassName={
            dm
              ? 'corgee_com_profile-picture-modal-react corgee_com_profile-picture-modal-react_darkMode'
              : 'corgee_com_profile-picture-modal-react'
          }
          onMouseEnter={this.onEnterModal}
          onMouseLeave={this.onRemoveHoverProfilePictureModal}
        >
          <Modal.Header className="divModalHeader_react_mini">
            <a
              data-title={'This data is retrieved from the Internal layer of the People card'}
              className="tooltop-icon enable-help-tooltip"
            >
              <i className="material-icons">info</i>
            </a>
          </Modal.Header>

          <Modal.Body className="divModalBody_react_mini">
            <div className="info">
              <div className="img"></div>
              <div className="buttons" style={{ paddingLeft: '0px !important' }}>
                {canOpenCard && (
                  <a className="profile-icons" onClick={this.openHomeProfileView}>
                    <i data-title={'User Home'} className="material-icons enable-help-tooltip">
                      home
                    </i>
                  </a>
                )}
                {canOpenCard && (
                  <a className="profile-icons" onClick={this.openUserProfileView}>
                    <i data-title={'Profile card'} className="material-icons enable-help-tooltip">
                      person
                    </i>
                  </a>
                )}
                {canOpenChat && (
                  <a className="profile-icons" onClick={this.openChatPerson}>
                    <i data-title={'Chat'} className="material-icons enable-help-tooltip">
                      chat
                    </i>
                  </a>
                )}
              </div>
            </div>
            <div className="text">
              {userInfo
                .filter(d => d.Priority >= 3)
                .map((d, index) => (
                  <div key={index} className="user_name enable-help-tooltip" data-title={d.Value}>
                    <span className="spanGrayTitle"></span>
                    <span>{d.Value}</span>
                  </div>
                ))}
              <div className="customfields">
                {userInfo
                  .filter(d => d.Priority <= 1)
                  .map((d, index) => (
                    <div key={index}>
                      <span className="spanGrayTitle">{d.Name}: </span>
                      <span className="spanGrayValue">{d.Value}</span>
                    </div>
                  ))}
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer style={{ display: 'none' }}></Modal.Footer>
        </Modal>
      </div>
    );
  }
}

// Wrapper to inject InfoWindow context into class component
const ProfilePictureModalWithContext: React.FC<ProfilePictureModalProps> = props =>
{
  const { openInfoWindow } = useInfoWindow();

  // Inject openInfoWindow into corgeeFunctions
  const corgeeFunctionsWithInfoWindow = {
    ...(props.corgeeFunctions || {}),
    openInfoWindow,
  };

  return <ProfilePictureModal {...props} corgeeFunctions={corgeeFunctionsWithInfoWindow} />;
};

export default ProfilePictureModalWithContext;
